<div *ngIf="dashboardView!='charts'" class="p-grid" [ngClass]="{'dashboard-charts': leadsReportsLoading && dashboardView!=''}">
    <div *ngIf="dashboardView==''" class="p-col-12">
        <app-filter [filterByInput]="cols" [filterByInputValue]="filterByInputValue" [selectedFilterGroup]="selectedFilterGroup"
            [showChannelFilter]="showChannelFilter" [channelList]="channelList" [selectedChannel]="selectedChannel" (onChangeChannel)="onChangeChannel($event)"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
            (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
            (onChangeRange)="onChangeRange(selectedWindow, $event)">
        </app-filter>
    </div>

    <div *ngIf="(!leadsReportsLoading && dashboardView!='') || dashboardView==''" class="p-col-12">
        <div class="card">
            <div class="main-content">
                <div id="divLeadsReport">
                    <ng-container  [ngSwitch]="selectedWindow">
                        <ng-container *ngSwitchCase="'leadsOwner'">
                            <app-table [reportType]="'groupTSBFData'" [groupTypeColName]="groupByFieldName" [reportName]="reportName" [reportDate]="reportDate"
                            [selectedWindow]="selectedWindow" [cols]="tableCols" [reportDatas]="reportsData"
                            [chartLabel]="chartLabel" [chartType]="dashboardView==''?'simpleBar':''" [barData]="leadsOwnerBarCharts"
                            [basicOptions]="basicOptions" [showTitle]="dashboardView==''"></app-table>
                        </ng-container>
                        <ng-container *ngSwitchCase="'leadsStage'">
                            <app-table [reportType]="'groupTSBFData'" [groupTypeColName]="groupByFieldName" [reportName]="reportName" [reportDate]="reportDate"
                            [selectedWindow]="selectedWindow" [cols]="tableCols" [reportDatas]="reportsData"
                            [chartLabel]="chartLabel" [chartType]="dashboardView==''?'stackedBar':''" [stackedBar]="leadsStageBarCharts"
                            [stackedOptions]="stackedOptions" [showTitle]="dashboardView==''"></app-table>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <app-table [reportType]="'simpleTB'" [reportName]="reportName" [reportDate]="reportDate"
                                [selectedWindow]="selectedWindow" [cols]="cols" [showTitle]="dashboardView==''"></app-table>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="leadsReportsLoading && dashboardView!=''" class="p-col-12">
        <div class="dashboard-charts p-d-flex">
            <app-block-content-spinner  height="100%" style="width: 100%"></app-block-content-spinner>
        </div>
    </div>

</div>

<app-filter *ngIf="dashboardView!=''" [filterByInput]="cols" [filterByInputValue]="filterByInputValue"
    [customSeletedDateFilter]="selectedDateFilter"
    [showChannelFilter]="showChannelFilter" [channelList]="channelList" [selectedChannel]="selectedChannel" (onChangeChannel)="onChangeChannel($event)"
    (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
    (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
    (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
    (onChangeRange)="onChangeRange(selectedWindow, $event)"
    [filterPopupOnly]="true" [displayFilterPopup]="displayFilterPopup"
    (onCloseFilterPopup)="closeFilterPopup()"
    (onAllFilterApply)="allFiltersChanges($event)">
</app-filter>

<div *ngIf="dashboardView=='charts'" class="dashboard-charts p-d-flex">
    <ng-container *ngIf="!leadsReportsLoading" [ngSwitch]="selectedWindow">
        <ng-container *ngSwitchCase="'leadsOwner'">
                <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
                <div style="flex-grow:1; width:100%">
                    <p-chart type="bar" height="100%" [data]="leadsOwnerBarCharts" [options]="basicOptions"></p-chart>
                </div>
        </ng-container>
        <ng-container *ngSwitchCase="'leadsStage'">
            <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
            <div style="flex-grow:1; width:100%">
                <p-chart type="bar" height="100%" [data]="leadsStageBarCharts" [options]="stackedOptions"></p-chart>
            </div>
        </ng-container>
    </ng-container>
    <app-block-content-spinner *ngIf="leadsReportsLoading" height="100%" style="width: 100%"></app-block-content-spinner>
</div>
